module.exports = __webpack_public_path__ + "img/xmas_ico01.3329687f.png";